<template>
    <ui-crud title="Devices" :fetch="fetch">

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search" @input="debouncedRefresh()"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="item.name"
                :subtitle="(item.used_by ? item.used_by.label : '—')"
                :metadata="item.created_at.substring(0,10)"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <assets-devices-form :add-item="addItem"></assets-devices-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <assets-devices-form :item="selectedItem" :edit="setEditMode"></assets-devices-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <assets-devices-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem"></assets-devices-show>
        </template>
    </ui-crud>
</template>

<script>
import { Device } from '@models'

export default {
    data () {
        return {
            search: '',
        }
    },
    methods: {
        async fetch () {
            return await Device.all(this.search)
        },
    }
}
</script>
